<template>
  <div class="justify-content-center">
    <div v-if="carregado">
      <midia ref="midia"></midia>
      <b-row>
        <b-col>
          <b-button
            pill
            class="float-left"
            @click="voltar"
            variant="outline-secondary"
            title="Voltar"
          >
            <font-awesome-icon
              :icon="['fa', 'arrow-left']"
              title="Voltar"
              class="mr-1"
            />
            Voltar
          </b-button>
        </b-col>
      </b-row>
      <h5 align="left" class="mt-2 mb-2">
        <strong>{{ titulo | stringUpper }}</strong>
      </h5>
      <b-row>
        <b-col>
          <b-card
            no-body
            style="background-color: #e5e5e5; border-color: #e5e5e5"
          >
            <b-row class="p-3">
              <b-col sm="6">
                <span>Nº Auto de Infração de Trânsito:
                  <strong class="text-dark">{{auto_infracao_transito.num_ait_composto}}</strong>
                </span>
              </b-col>

              <b-col align="right">
                <b-button-group size="sm">
                  <b-link
                    v-if="exibirImagemRadar"
                    @click="verificarAntesDownload('imagem')"
                    variant="outline-secondary"
                    class="text-dark mr-3"
                  >
                    <font-awesome-icon
                      :icon="['fa', 'camera']"
                      title="Fechar"
                      size="lg"
                    />
                    Imagem do Radar
                  </b-link>
                  <b-link
                    v-if="exibirVideoRadar"
                    variant="outline-secondary"
                    @click="verificarAntesDownload('video')"
                    class="text-dark mr-3"
                  >
                    <font-awesome-icon
                      :icon="['fa', 'video']"
                      title="Fechar"
                      size="lg"
                    />
                    Vídeo do Radar
                  </b-link>
                  <b-link
                    v-if="exibeBtnCopia"
                    :disabled="desabilitarBtnCopia"
                    @click="abrirCopia"
                    variant="outline-secondary"
                    class="text-dark"
                  >
                    <font-awesome-icon
                      :icon="['fa', 'copy']"
                      title="Fechar"
                      size="lg"
                    />
                    Cópia do AIT
                  </b-link>
                </b-button-group>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row v-show="!emErro" class="mt-3">
        <b-col>
          <b-card no-body class="shadow border-white">

            <b-tabs card v-model="tabIndex" @input="mudouAba" active-nav-item-class="font-weight-bold bg-white" ref="panelAbas">

              <b-tab id="infracao">
                <template slot="title">
                  <font-awesome-icon icon="edit" class="text-primary" />Infração
                </template>
                <aba-infracao :dadosAit="dadosAit" :auto_infracao_transito="auto_infracao_transito" ></aba-infracao>
              </b-tab>

              <b-tab v-if="isMultaNIC"  id="nicorigem">
                <template slot="title">
                  <font-awesome-icon icon="edit" class="text-success" />
                  Infração de Origem
                </template>
                <aba-infracao v-if="dadosAitGerador!==null"  :dadosAit="dadosAitGerador" :auto_infracao_transito="auto_infracao_transito_nic" multaNic></aba-infracao>
              </b-tab>               

              <b-tab id="pagamento">
                <template slot="title">
                  <font-awesome-icon icon="barcode" class="text-secondary" />
                  Guia Pagamento
                </template>
                <aba-pagamento ref="abaPagamento" :multa_nic="dadosAit" :auto_infracao_transito="auto_infracao_transito"></aba-pagamento>
              </b-tab>

              <b-tab v-if="!isMultaNIC" id="condutor">
                <template slot="title">
                  <font-awesome-icon icon="user" class="text-success" />
                  Condutor Infrator
                </template>
                <aba-condutor ref="abaCondutor" :auto_infracao_transito="auto_infracao_transito"></aba-condutor>
              </b-tab>             

              <b-tab id="nit">
                <template slot="title">
                  <font-awesome-icon icon="envelope" class="text-warning" />
                  Notificação Autuação
                </template>
                <aba-notificacao-nit ref="notificacaoNit" :dadosAit="dadosAit" :auto_infracao_transito="auto_infracao_transito"></aba-notificacao-nit>
              </b-tab>

              <b-tab id="nap">
                <template slot="title">
                  <font-awesome-icon icon="envelope" class="text-danger" />
                  Notificação Penalidade
                </template>
                <aba-notificacao-nap ref="notificacaoNap" :dadosAit="dadosAit" :auto_infracao_transito="auto_infracao_transito"></aba-notificacao-nap>
              </b-tab>

              <b-tab id="defesa">
                <template slot="title">
                  <font-awesome-icon icon="balance-scale" class="text-info" />
                  Defesa Autuação
                </template>
                <aba-defesa ref="abaDefesa" :auto_infracao_transito="auto_infracao_transito"></aba-defesa>
              </b-tab>

              <b-tab v-if="!isMultaNIC && (auto_infracao_transito.vigencia_codigo_infracao.pontuacao == 3 || auto_infracao_transito.vigencia_codigo_infracao.pontuacao == 4)" id="advertencia">
                <template slot="title">
                  <font-awesome-icon icon="triangle-exclamation" style="color: darkorange"/>
                  Advertência
                </template>
                <aba-advertencia ref="abaAdvertencia" :auto_infracao_transito="auto_infracao_transito"></aba-advertencia>
              </b-tab>

              <b-tab id="jari">
                <template slot="title">
                  <font-awesome-icon icon="balance-scale" class="text-info" />Recursos JARI/CETRAN
                </template>
                <aba-jari-cetran ref="abaJariCetran" :auto_infracao_transito="auto_infracao_transito"></aba-jari-cetran>
              </b-tab>

              <b-tab id="restituicao">
                <template slot="title">
                  <font-awesome-icon class="text-success"  icon="money-bill-transfer"  />Restituição Multa
                </template>
                <aba-restituicao-pagamento ref="abaRestituicao" :auto_infracao_transito="auto_infracao_transito"></aba-restituicao-pagamento>
              </b-tab>

            </b-tabs>

          </b-card>
        </b-col>
      </b-row>

      <b-row class="mt-3" v-show="emErro">
        <b-col sm="10">
          <b-alert show variant="danger">Não foi possível carregar o AIT.</b-alert>
        </b-col>
      </b-row>
      <modal-copia-ait ref="modalCopiaAit"></modal-copia-ait>
    </div>
  </div>
</template>

<script>
import { helperDatas } from "@/helpers";
import AutoInfracaoTransito from "@/models/AutoInfracaoTransito";
import AitTalaoManual from "@/models/AitTalaoManual";
import AitAplicativo from "@/models/AitAplicativo";
import AitEletronico from "@/models/AitEletronico";
import abaInfracao from "./aba/infracaoAba";
import abaCondutor from "./aba/condutorAba";
import abaNotificacaoNit from "./aba/notificacaoNitAba";
import abaNotificacaoNap from "./aba/notificacaoNapAba";
import abaRestituicaoPagamento from "./aba/restituicaoPagamentoAba";

import abaDefesa from "./aba/defesaAba";
import abaAdvertencia from "./aba/advertenciaAba";
import abaJariCetran from "./aba/jariCetranAba";
import abaPagamento from "./aba/pagamentoAba";
import helpers from "@/helpers";
import Midia from "@/components/MidiaComponent.vue";
import modalCopiaAit from "./aba/_modalCopiaAit.vue";
import moment from "moment";

export default {
  components: {
    abaInfracao,
    abaCondutor,
    abaNotificacaoNit,
    abaNotificacaoNap,
    abaDefesa,
    abaJariCetran,
    abaPagamento,
    abaAdvertencia,
    Midia,
    modalCopiaAit,
    abaRestituicaoPagamento
  },

  data() {
    return {
      titulo: "Detalhamento da Multa",
      dadosAit: {},
      totalErros: 0,
      tabIndex: 0,
      carregado: false,
      emErro: false,
      auto_infracao_transito: new AutoInfracaoTransito(),
      viewstateanterior: null,
      desabilitarBtnCopia: false,
      exibeBtnCopia: false,

      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: false,
      },
      lista_processo: [],
      exibirImagemRadar: false,
      exibirVideoRadar: false,
      imgMidia: null,
      tipoResource: null,
      listaCpfCnpj: [],
      dadosAitGerador: null,
      auto_infracao_transito_nic:null,      
    };
  },

  /* */
  computed: {
    isTalaoManual() {
      return this.auto_infracao_transito.isTalaoManual();
    },
    isAplicativo() {
      return this.auto_infracao_transito.isAplicativo();
    },
    isEletronico() {
      return this.auto_infracao_transito.isEletronico();
    },
    isMultaNIC() {
      return this.auto_infracao_transito.isMultaNIC()
    },
    
    mobile() {
      return helpers.isMobile();
    },
  },

  watch: {},

  methods: {
    verificarDadosEletronicos() {
      var existePropriedade = Object.prototype.hasOwnProperty.call(
        this.dadosAit,
        "documento_ait_eletronico"
      );
      if (existePropriedade) {
        this.exibirImagemRadar = this.dadosAit.documento_ait_eletronico.some(
          (el) => el.tipo_midia == "imagem"
        )
          ? true
          : false;
        this.exibirVideoRadar = this.dadosAit.documento_ait_eletronico.some(
          (el) => el.tipo_midia == "video"
        )
          ? true
          : false;
      }
    },

    abrirMidia(tipo) {
      this.$refs.midia.exibir(true, tipo);
    },

    verificarAntesDownload(tipo) {
      var filtrado = this.dadosAit.documento_ait_eletronico.filter(function (
        obj
      ) {
        return obj.tipo_midia == tipo;
      });

      if (!this.mobile) {
        this.abrirMidia(tipo);
      } else {
        if (tipo == "video" && filtrado.lenght > 1) {
          filtrado.forEach((element) => {
            this.downloadMidia(element);
          });
        } else {
          this.downloadMidia(filtrado[0]);
        }
      }
    },

    downloadMidia(dados) {
      this.$api.Storage.downloadMidia({ hash_arquivo: dados.hash_arquivo , prefix: dados.prefix})
        .then((response) => {
          var fileDownload = require("js-file-download");
          fileDownload(
            response.data,
            this.dadosAit.auto_infracao_transito.num_ait_composto +
              "_" +
              dados.tipo_midia +
              "_radar",
            dados.mimetype
          );
        })
        .catch(() => {});
    },

    voltar() 
    {
      var objViewstateanterior = JSON.parse(this.viewstateanterior);
      if (
        this.viewstateanterior != null &&
        objViewstateanterior.componente == "placaRenavam"
      ) {
        this.$router.push({
          name: "PlacaRenavamView",
          params: { parametrosProp: JSON.parse(this.viewstateanterior) },
        });
      } else {
        this.$router.push({
          name: "CpfCnpjView",
          params: { parametrosProp: JSON.parse(this.viewstateanterior) },
        });
      }
    },


    getDadosAitNic()
    {
      if(this.dadosAitGerador === null)
            {
              let params = {hash: this.auto_infracao_transito.hash}
              this.$api.Multa.buscarDetalhamentoNic(params)
              .then(async response => 
              {              
                  if (response.data.success && response.data.data) 
                  {
                      this.auto_infracao_transito_nic = new AutoInfracaoTransito(response.data.data.detalhamentoGerador.auto_infracao_transito);
                      if (this.auto_infracao_transito_nic.isTalaoManual()) 
                      {
                        this.dadosAitGerador = new AitTalaoManual(response.data.data.detalhamentoGerador);
                        this.dadosAitGerador.ait_digitalizado_nome_minio == null ? this.desabilitarBtnCopia = true : this.desabilitarBtnCopia = false;
                      }
                      //Ait Talão
                      else if (this.auto_infracao_transito_nic.isAplicativo()) 
                      {
                        this.dadosAitGerador = new AitAplicativo(response.data.data.detalhamentoGerador);
                      }
                      //Ait Aplicativo
                      else 
                      {
                        this.dadosAitGerador = new AitEletronico(response.data.data.detalhamentoGerador);
                      }                    
                  }            

              })/*.catch(() => 
              {
                  this.carregado = true;
                  this.emErro = true;
                  this.auto_infracao_transito = new AutoInfracaoTransito({id: id_auto_infracao_transito});
              })*/;            
            }      
    },

    mudouAba(index) 
    {
      let abas = this.$refs.panelAbas.getTabs();

      if (abas[index].id == "nicorigem") this.getDadosAitNic();
      else if (abas[index].id == "condutor") this.$refs.abaCondutor.loadInfos();
      else if (abas[index].id == "advertencia") this.$refs.abaAdvertencia.loadInfos();
      else if (abas[index].id == "jari") this.$refs.abaJariCetran.loadInfos();
      else if (abas[index].id == "nit") this.$refs.notificacaoNit.loadInfos();
      else if (abas[index].id == "nap") this.$refs.notificacaoNap.loadInfos();
      else if (abas[index].id == "defesa") this.$refs.abaDefesa.loadInfos();
      else if (abas[index].id == "restituicao") this.$refs.abaRestituicao.loadInfos();
    },

    dataHoraBrasil(vlaor) {
      return helperDatas.dataHoraBrasil(vlaor);
    },
    dataBrasil(vlaor) {
      return helperDatas.dataBrasil(vlaor);
    },

    abrirCopia(imgToPdf = true) {
      if (!this.mobile) {
        this.$refs.modalCopiaAit.abrirSintetico(
          this.auto_infracao_transito,
          true
        );
      } else {
        this.$api.Multa.buscarResourceAitPorTipo({
          hash: this.auto_infracao_transito.hash,
        }).then((response) => {
          if (response.data.success) {
            if (
              Object.prototype.hasOwnProperty.call(
                response.data.data,
                "ait_talao_manual"
              ) &&
              !imgToPdf
            ) {
              this.imgMidia =
                "data:image/png;base64," + response.data.data.resource;
            } else {
              this.imgMidia =
                "data:application/pdf;base64," + response.data.data.resource;
            }
            var a = document.createElement("a");
            a.href = this.imgMidia;
            a.download =
              this.auto_infracao_transito.num_ait_composto + "_copia_autuacao";
            a.click();
          }
        });
      }
    },

    async inicializar(hash) {
      await this.buscarAutoInfracao(hash);
      this.setExibeBtnCopia(hash);
    },

    /*  */
    buscarAutoInfracao(hash) {
      this.carregado = false;
      this.emErro = false;
      var params = { hash: hash };
      return this.$api.Multa.buscarAit(params)
        .then(async (response) => {
          if (response.data.success && response.data.data) 
          {
            this.carregado = true;

            this.auto_infracao_transito = new AutoInfracaoTransito(response.data.data.auto_infracao_transito);

            //Ait Eletronico
            if (this.auto_infracao_transito.isTalaoManual()) 
            {
              this.dadosAit = new AitTalaoManual(response.data.data);
              this.dadosAit.ait_digitalizado_nome_minio == null ? (this.desabilitarBtnCopia = true) : (this.desabilitarBtnCopia = false);
            }
            //Ait Talão
            else if (this.auto_infracao_transito.isAplicativo()) 
            {
              this.dadosAit = new AitAplicativo(response.data.data);
            }
            //Ait Aplicativo
            else if (this.auto_infracao_transito.isEletronico())
            {
              this.dadosAit = new AitEletronico(response.data.data);
            }
            else this.dadosAit = response.data.data;
            this.verificarDadosEletronicos();
            if (this.isEletronico) 
            {
              this.$nextTick(() => {
                var obj = { midia: this.dadosAit.documento_ait_eletronico };
                this.$refs.midia.preencher(obj);
              });
            }
          } 
          else 
          {
            this.carregado = true;
            this.emErro = true;
            this.auto_infracao_transito = new AutoInfracaoTransito({
              hash: hash,
            });
          }
        })
        .catch(() => 
        {
          this.carregado = true;
          this.emErro = true;
          this.auto_infracao_transito = new AutoInfracaoTransito({
            hash: hash,
          });
        });
    },

    listaCpfCnpf() {
      var keys = Object.keys(this.$store.getters.userInfo.attributes);
      const result = keys.filter(
        (element) => element.substring(10, 0) == "govbr_cnpj"
      );
      let listaCpfCnpj = [];
      listaCpfCnpj.push(this.$store.getters.userInfo.preferred_username);
      if (result.length > 0) {
        result.forEach((element) => {
          listaCpfCnpj.push(element.substring(25, 11));
        });
      }
      return listaCpfCnpj;
    },

    async setExibeBtnCopia(hash){
      this.exibeBtnCopia = false;

      if(this.auto_infracao_transito.isAplicativo()){
        this.exibeBtnCopia = moment(this.auto_infracao_transito.data_processamento_sram).isSameOrAfter('2022-08-26') && await this.verificaCpfCnpjAssociadoPessoaAit(hash);
      }else if(this.auto_infracao_transito.isEletronico()){
        this.exibeBtnCopia = moment(this.auto_infracao_transito.data_processamento_sram).isSameOrAfter('2022-09-01');
      }else if(this.auto_infracao_transito.isTalaoManual()){
        this.exibeBtnCopia = moment(this.auto_infracao_transito.data_processamento_sram).isSameOrAfter('2022-09-01') &&  await this.verificaCpfCnpjAssociadoPessoaAit(hash);
      }else if(this.auto_infracao_transito.isMultaNIC()){
        this.exibeBtnCopia = true;
      }
    },

    verificaCpfCnpjAssociadoPessoaAit(hash){
      return this.$api.Multa.verificaCpfCnpjAssociadoPessoaAit({
        hash: hash,
        listaCpfCnpj: this.listaCpfCnpf()
      })
        .then(async (response) => {
          if (response.data.success && response.data.data) {
            return response.data.data;
          }
        })
        .catch(() => {});
    },
  },

  /*  */
  mounted() {
    if (this.$route.query.hash) {
      this.inicializar(this.$route.query.hash);
      if (this.$route.query.viewstateanterior) {
        this.viewstateanterior = this.$route.query.viewstateanterior;
      }
    } else {
      this.$router.push({ name: "consulta_multas" });
    }
  },
};
</script>

<style scoped>
.imagem_div {
  height: 600px !important;
}

.imagem {
  max-width: 100%;
  width: 600px;
  height: 600px !important;
}

input .form-control-sm {
  font-weight: 700 !important;
}
</style>